const syncMapUri = "https://api.jsonstorage.net/v1/json/f53e5039-2300-46fa-b003-08a222aca809/d0bbaf8a-6df2-4a3a-8319-35c8ff2e8d8e"
const apiKey = "b88f46c6-683a-4904-8b3c-515c69fe8ea1"

export class Syncer {
    static setIdentifier(identifier) {
        const existing_identifier = window.localStorage.getItem("syncIdentifier")
        if (existing_identifier == identifier && window.localStorage.getItem("syncUri")) {
            console.log("Identifier already set, nothing to do")
            return
        }
        window.localStorage.setItem("syncIdentifier", identifier)

        const xhr = new XMLHttpRequest()
        xhr.open("GET", `${syncMapUri}?apiKey=${apiKey}`, false)
        xhr.send(null)

        let syncMap = JSON.parse(xhr.response)
        console.log(syncMap)
        if (identifier in syncMap) {
            console.log("Found uri in map for identifier")
            window.localStorage.setItem("syncUri", syncMap[identifier])
            return
        }
        console.log("Failed to find identifier")

        // Send empty data to create entry, and save the URI
        xhr.open("POST", `https://api.jsonstorage.net/v1/json?apiKey=${apiKey}&name=${identifier}`, false)
        xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8")
        xhr.send("{}")
        console.log("Finished creating new blank entry")
        const uri = JSON.parse(xhr.response)["uri"]

        // Update the syncMap with the URI
        syncMap[identifier] = uri
        let xhr2 = new XMLHttpRequest()
        xhr2.open("PUT", `${syncMapUri}?apiKey=${apiKey}`, false)
        xhr2.setRequestHeader("Content-Type", "application/json")
        xhr2.onreadystatechange = () => {
            if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
                console.log("Successfully added new identifier to sync map")
            }
        }
        xhr2.send(JSON.stringify(syncMap))
        window.localStorage.setItem("syncUri", uri)
    }

    static save(notebooks) {
        const identifier = window.localStorage.getItem("syncIdentifier")
        const syncUri = window.localStorage.getItem("syncUri")

        const xhr = new XMLHttpRequest()
        xhr.open("PUT", `${syncUri}?apiKey=${apiKey}`, true)
        xhr.setRequestHeader("Content-Type", "application/json")
        xhr.onreadystatechange = () => {
            if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
                console.log("Sync Successful!")
            }
        }

        xhr.send(JSON.stringify(notebooks))
    }

    static load(callback) {
        const syncUri = window.localStorage.getItem("syncUri")
        if (syncUri === null) {
            alert("Unable to sync!")
        }
        else {
            const xhr = new XMLHttpRequest()
            xhr.open("GET", syncUri, true)
            xhr.onload = () => {
                const notebooks = JSON.parse(xhr.response)
                callback(notebooks)
            }
            xhr.send(null)
        }
    }
}
